import React, { useState, useEffect } from 'react';
import Fuse from 'fuse.js';
import { useAllInOneContext, useListRefContext } from '../../../context';
import { COLORS, COLORS_L2 } from '../../../constants';
import { Core } from '../..';
import { FocusBackground } from '../../core/styles';
import { CSSTransition } from 'react-transition-group';
import '../../core/styles/styles.css';
import {
  Redirect,
  SearchBar,
  LinkButton,
  SearchButton,
  ResultBox,
  Container,
} from './styles';
import { FaSearch, FaTimesCircle, FaExternalLinkAlt } from 'react-icons/fa';

export const Search = ({ isMobile = false }) => {
  const { lists, allTasks } = useAllInOneContext();
  let { listRefs } = useListRefContext();

  const [searchTerm, setSearchTerm] = useState('');
  const [startSearch, setStartSearch] = useState(false);
  const [results, setResults] = useState();
  const [target, setTarget] = useState();

  useEffect(() => {
    if (startSearch) setTarget(allTasks.concat(lists));
    else setTarget();
  }, [startSearch]);

  const cancelAll = () => {
    setStartSearch(false);
    setSearchTerm('');
  };

  useEffect(() => {
    if (searchTerm && searchTerm.length) {
      const fuse = new Fuse(target, {
        keys: ['title', 'name'],
      });
      const tempResults = fuse.search(searchTerm).map(({ item }) => item);

      if (tempResults.length > 0) setResults(tempResults);
    } else setResults();
  }, [searchTerm]);

  return (
    <>
      {!isMobile && (
        <SearchButton onClick={() => setStartSearch(true)}>
          <FaSearch />
        </SearchButton>
      )}
      {isMobile && (
        <SearchBar
          forButton={true}
          startSearch={startSearch}
          style={{ background: '#C4CAD1' }}
        >
          <div className='search-icon'>
            <FaSearch />
          </div>

          <input
            className='search-input'
            placeholder='Search'
            onFocus={() => setStartSearch(true)}
            style={{ background: 'transparent' }}
          />

          <div
            className='search-clear'
            style={{
              visibility: 'hidden',
            }}
          >
            <FaTimesCircle />
          </div>
        </SearchBar>
      )}

      <FocusBackground
        showBox={startSearch}
        onClick={() => {
          cancelAll();
        }}
      ></FocusBackground>

      <Container isMobile={isMobile}>
        <CSSTransition
          in={startSearch}
          timeout={300}
          classNames='display'
          unmountOnExit
        >
          <div
            style={{
              display: 'flex',
              width: 'fit-content',
              pointerEvents: 'auto',
              margin: 'auto',
              alignItems: 'center',
            }}
          >
            <SearchBar forButton={false} style={{backdropFilter: 'blur(5px)'}}>
              <div className='search-icon'>
                <FaSearch />
              </div>

              <input
                className='search-input'
                value={searchTerm}
                onChange={({ target }) => setSearchTerm(target.value)}
                placeholder='Search'
                autoFocus
              />

              <div
                className='search-clear'
                style={{
                  visibility: searchTerm.length > 0 ? 'visible' : 'hidden',
                }}
                onClick={() => setSearchTerm('')}
              >
                <FaTimesCircle />
              </div>
            </SearchBar>

            <LinkButton
              style={{ marginLeft: '10px' }}
              onClick={() => {
                cancelAll();
              }}
            >
              Cancel
            </LinkButton>
          </div>
        </CSSTransition>
        {results && (
          <ResultBox
            style={{
              borderRadius: '24px',
              maxHeight: '70vh',
              maxWidth: '60vw',
              minWidth: '50vw',
              overflow: 'hidden',
              pointerEvents: 'auto',
              marginTop: '10px',
   
            }}
          >
            <Core.List childWidth='full' addFlex={true}>
              {results.map((item, index) => {
                const foundIndex =
                    'title' in item
                      ? lists.findIndex((list) => list.docID == item.listID)
                      : lists.findIndex((list) => list.docID == item.docID),
                  list = lists[foundIndex],
                  color = COLORS[list.color],
                  color_l2 = COLORS_L2[list.color];

                return (
                  <>
                    <div key={index}>
                      {'title' in item ? (
                        <Redirect
                          forType='Task'
                          color={color}
                          color_l2={color_l2}
                          onClick={() => {
                            listRefs[foundIndex].click();
                            cancelAll();
                          }}
                        >
                          <div className='task'>
                            <div>{item.title}</div>
                            <div className='list-box'>
                              <div className='list'>{list.name}</div>
                            </div>
                          </div>
                          <div className='icon'>
                            <FaExternalLinkAlt />
                          </div>
                        </Redirect>
                      ) : (
                        <Redirect
                          forType='List'
                          color={color}
                          color_l2={color_l2}
                          onClick={() => {
                            listRefs[foundIndex].click();
                            cancelAll();
                          }}
                        >
                          <span className='list-dot'></span>
                          <div className='list'>{item.name}</div>
                          <div className='icon'>
                            <FaExternalLinkAlt />
                          </div>
                        </Redirect>
                      )}
                    </div>
                  </>
                );
              })}
            </Core.List>
          </ResultBox>
        )}
      </Container>
    </>
  );
};
